import { useFormContext } from 'react-hook-form';
import { SERVICE_PROVIDERS } from 'modules/graphql/types';
import { useUpdateAccount } from '../../../../hooks';
import { ITERABLE_SMS } from '../../../../constants';
import { useSendingPlatformsQueryContext } from '../../../../contexts';
import { getEspRadioOptionsForSendingPlatform } from '../../../../utils';
import { AccountTypesRadioListField } from '../../Shared/AccountTypesRadioListField';
import { GreyBorderedContainer } from '../../styles';
import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { ClearableConnectedInputField } from '../../Shared/ClearableConnectedInputField';
import { EditModalRHF } from '../../Shared/EditModalRHF';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';

const { ESP, NAME, API_ENDPOINT, API_KEY, SIGNING_SECRET, EDIT_SIGNING_SECRET, EDIT_API_KEY } =
  ESP_ACCOUNT_PAYLOAD_FIELDS;

export const IterableSmsEditModal = () => {
  const { espDefinitions = [] } = useSendingPlatformsQueryContext();
  const { updateAccount } = useUpdateAccount();

  const {
    formState: { defaultValues = {} },
  } = useFormContext();
  const esp = defaultValues[ESP];

  const espOptions = getEspRadioOptionsForSendingPlatform(ITERABLE_SMS, espDefinitions, esp);

  return (
    <EditModalRHF onSubmit={updateAccount}>
      <AccountTypesRadioListField labelText="Account type" name={ESP} options={espOptions} />
      <GreyBorderedContainer>
        {esp === SERVICE_PROVIDERS.TELNYX && (
          <>
            <ConnectedInputField name={NAME} labelText="Name" />
            <ClearableConnectedInputField
              name={API_KEY}
              labelText="API key"
              wasEditedFieldName={EDIT_API_KEY}
            />
            <ClearableConnectedInputField
              name={SIGNING_SECRET}
              labelText="Signing secret"
              wasEditedFieldName={EDIT_SIGNING_SECRET}
            />
          </>
        )}
        {esp === SERVICE_PROVIDERS.TWILIO && (
          <>
            <ConnectedInputField
              name={NAME}
              labelText="API key SID"
              placeholder="SKxxxxxxxxxxxxxxxx"
            />
            <ClearableConnectedInputField
              name={API_KEY}
              labelText="API key secret"
              wasEditedFieldName={EDIT_API_KEY}
            />
            <ConnectedInputField
              name={API_ENDPOINT}
              labelText="Account SID"
              placeholder="ACxxxxxxxxxxxxxxxx"
            />
          </>
        )}
      </GreyBorderedContainer>
    </EditModalRHF>
  );
};
